import { motion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

export default function About() {
    return (
        <section id="about" data-testid="about-section" className="relative py-32 md:py-48">
            <div className="mx-auto max-w-[1480px] px-6 sm:px-12 md:px-20">
                {/* Chapter header */}
                <motion.div
                    initial={{ opacity: 0, y: 14 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, margin: "-15%" }}
                    transition={{ duration: 0.7, ease: EASE }}
                    className="mb-16 flex items-baseline gap-6 border-b border-sb pb-6"
                >
                    <span className="font-mono text-[11px] uppercase tracking-[0.28em] text-sb-mint">
                        01 · Index
                    </span>
                    <span className="hidden sm:inline font-mono text-[10px] uppercase tracking-[0.24em] text-sb-muted">
                        / Of intent
                    </span>
                    <span className="ml-auto hidden md:inline font-mono text-[10px] uppercase tracking-[0.24em] text-sb-muted">
                        About the studio
                    </span>
                </motion.div>

                {/* Mega quote */}
                <motion.h2
                    initial={{ opacity: 0, y: 24 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, margin: "-10%" }}
                    transition={{ duration: 0.9, ease: EASE, delay: 0.05 }}
                    className="balance max-w-[26ch] text-[clamp(1.875rem,3.8vw,3.5rem)] font-medium leading-[1.08] tracking-[-0.025em]"
                >
                    A studio for software that
                    <span className="font-serif italic text-sb-mint"> thinks</span>.
                    Products that are quiet, considered, and quietly{" "}
                    <span className="font-serif italic">inevitable</span>.
                </motion.h2>

                {/* Two-column body */}
                <div className="mt-20 grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-16">
                    <motion.div
                        initial={{ opacity: 0, y: 18 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true, margin: "-10%" }}
                        transition={{ duration: 0.8, ease: EASE }}
                        className="md:col-span-5 space-y-6"
                    >
                        <p className="font-mono text-[10px] uppercase tracking-[0.24em] text-sb-muted">
                            ¶ Premise
                        </p>
                        <p className="text-base md:text-lg font-light leading-relaxed text-sb-soft">
                            SysBrains is a focused engineering studio. We design and build modern
                            software products. Digital systems that feel inevitable and
                            quietly intelligent.
                        </p>
                        <p className="text-base md:text-lg font-light leading-relaxed text-sb-soft">
                            Our work spans product strategy, architecture, engineering, and
                            automation. We treat every technical decision as a design decision.
                        </p>
                    </motion.div>

                    <motion.div
                        initial={{ opacity: 0, y: 18 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true, margin: "-10%" }}
                        transition={{ duration: 0.8, ease: EASE, delay: 0.08 }}
                        className="md:col-span-6 md:col-start-7 space-y-6"
                    >
                        <p className="font-mono text-[10px] uppercase tracking-[0.24em] text-sb-muted">
                            ¶ Posture
                        </p>
                        <p className="text-base md:text-lg font-light leading-relaxed text-sb-soft">
                            We stay small on purpose. A high-signal team, deep collaboration,
                            and a strong opinion that good software is the outcome of thinking
                            clearly, then building precisely.
                        </p>

                        {/* Stat trio */}
                        <div className="pt-6 grid grid-cols-3 gap-4 border-t border-sb">
                            {[
                                { k: "Founded", v: "2025" },
                                { k: "Team", v: "Senior, focused" },
                                { k: "Slots", v: "2 / quarter" },
                            ].map((s) => (
                                <div key={s.k} className="pt-5">
                                    <div className="font-mono text-[10px] uppercase tracking-[0.22em] text-sb-muted">{s.k}</div>
                                    <div className="mt-2 font-serif text-xl md:text-2xl text-sb">{s.v}</div>
                                </div>
                            ))}
                        </div>
                    </motion.div>
                </div>
            </div>
        </section>
    );
}
